import { render, staticRenderFns } from "./TakipSorgulaIslemDetayView.vue?vue&type=template&id=662e0d7a&scoped=true"
import script from "./TakipSorgulaIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipSorgulaIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e0d7a",
  null
  
)

export default component.exports